export default __webpack_public_path__ + "static/media/Rectangle28.d05a8f78.png";